import { render, staticRenderFns } from "./Bloco9Agradecimento.vue?vue&type=template&id=33259df0&scoped=true&"
import script from "./Bloco9Agradecimento.vue?vue&type=script&lang=js&"
export * from "./Bloco9Agradecimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33259df0",
  null
  
)

export default component.exports